'use client';

import { c as _c } from "react/compiler-runtime";
import type { Cruz, Spotted } from '@cruz-com/lookup';
import dayjs from 'dayjs';
import NextLink from 'next/link';
import slugify from 'slugify';
import { Bullet, CardHeader, CardPhoto, Divider } from '@/components';
import { pages } from '@/settings';
const UserInfo = t0 => {
  const $ = _c(16);
  const {
    userId,
    userDisplay
  } = t0;
  const userName = `${userDisplay?.first_name} ${userDisplay?.last_name}`;
  let t1;
  if ($[0] !== userId || $[1] !== userName) {
    t1 = pages.userSpotted.href.replace("[name]", slugify(userName, {
      lower: true
    })).replace("[id]", userId);
    $[0] = userId;
    $[1] = userName;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const userHref = t1;
  let t2;
  if ($[3] !== userName) {
    t2 = <h3 className="m-0! p-0! text-sm/6! font-medium!">{userName}</h3>;
    $[3] = userName;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <Bullet className="text-xs/6" aria-hidden="true" />;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <span className="sr-only">Location: </span>;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  const t5 = userDisplay?.location?.city;
  const t6 = userDisplay?.location?.state_abbr;
  let t7;
  if ($[7] !== t5 || $[8] !== t6) {
    t7 = <address className="m-0 text-xs/6 font-light not-italic">{t4}{t5}, {t6}</address>;
    $[7] = t5;
    $[8] = t6;
    $[9] = t7;
  } else {
    t7 = $[9];
  }
  let t8;
  if ($[10] !== t2 || $[11] !== t7) {
    t8 = <div className="dark:hover:bg-zinc-transparent flex items-center gap-2 px-4 py-3 hover:bg-zinc-100">{t2}{t3}{t7}</div>;
    $[10] = t2;
    $[11] = t7;
    $[12] = t8;
  } else {
    t8 = $[12];
  }
  let t9;
  if ($[13] !== t8 || $[14] !== userHref) {
    t9 = <NextLink hrefLang="en" href={userHref} className="block">{t8}</NextLink>;
    $[13] = t8;
    $[14] = userHref;
    $[15] = t9;
  } else {
    t9 = $[15];
  }
  return t9;
};
type Props = {
  d: Spotted.Summary;
  showUser: boolean;
  showPhotoCount?: boolean;
};
export const SpottedCard = t0 => {
  const $ = _c(49);
  const {
    d,
    showUser,
    showPhotoCount
  } = t0;
  const t1 = `Spotted Vehicle: ${d.title}`;
  const t2 = d.detail_url || "";
  const t3 = `Photo of ${d.title}`;
  const t4 = showPhotoCount ? d.photo_count : null;
  const t5 = d.post_status_id === -2;
  let t6;
  if ($[0] !== d.photo_preview_url || $[1] !== t3 || $[2] !== t4 || $[3] !== t5) {
    t6 = <CardPhoto alt={t3} photoUrl={d.photo_preview_url} photoCount={t4} isDeleted={t5} />;
    $[0] = d.photo_preview_url;
    $[1] = t3;
    $[2] = t4;
    $[3] = t5;
    $[4] = t6;
  } else {
    t6 = $[4];
  }
  let t7;
  if ($[5] !== d.title) {
    t7 = <h2 className="my-0! truncate py-0! text-base! font-semibold!">{d.title}</h2>;
    $[5] = d.title;
    $[6] = t7;
  } else {
    t7 = $[6];
  }
  let t8;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = <span className="sr-only">Location: </span>;
    $[7] = t8;
  } else {
    t8 = $[7];
  }
  const t9 = d.location_name;
  let t10;
  let t11;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = <Bullet className="mx-2" />;
    t11 = <span className="sr-only">Spotted: </span>;
    $[8] = t10;
    $[9] = t11;
  } else {
    t10 = $[8];
    t11 = $[9];
  }
  const t12 = d.date_create;
  let t13;
  if ($[10] !== d.date_create) {
    t13 = dayjs(d.date_create).fromNow();
    $[10] = d.date_create;
    $[11] = t13;
  } else {
    t13 = $[11];
  }
  let t14;
  if ($[12] !== d.date_create || $[13] !== t13) {
    t14 = <time dateTime={t12}>{t13}</time>;
    $[12] = d.date_create;
    $[13] = t13;
    $[14] = t14;
  } else {
    t14 = $[14];
  }
  let t15;
  if ($[15] !== d.location_name || $[16] !== t14) {
    t15 = <address className="m-0 truncate py-0.5 text-sm/6 font-light text-zinc-800 not-italic dark:text-zinc-400">{t8}{t9}{t10}{t11}{t14}</address>;
    $[15] = d.location_name;
    $[16] = t14;
    $[17] = t15;
  } else {
    t15 = $[17];
  }
  const t16 = d?.view_count || 0;
  let t17;
  if ($[18] !== t16) {
    t17 = t16.toLocaleString();
    $[18] = t16;
    $[19] = t17;
  } else {
    t17 = $[19];
  }
  let t18;
  if ($[20] !== t17) {
    t18 = <div className="m-0"><span className="text-sm font-medium">{t17}</span> views</div>;
    $[20] = t17;
    $[21] = t18;
  } else {
    t18 = $[21];
  }
  let t19;
  if ($[22] === Symbol.for("react.memo_cache_sentinel")) {
    t19 = <Bullet aria-hidden="true" />;
    $[22] = t19;
  } else {
    t19 = $[22];
  }
  const t20 = d?.vote?.up?.count || 0;
  let t21;
  if ($[23] !== t20) {
    t21 = t20.toLocaleString();
    $[23] = t20;
    $[24] = t21;
  } else {
    t21 = $[24];
  }
  let t22;
  if ($[25] !== t21) {
    t22 = <span className="text-sm font-medium">{t21}</span>;
    $[25] = t21;
    $[26] = t22;
  } else {
    t22 = $[26];
  }
  const t23 = (d?.vote?.up?.count || 0) !== 1 && "s";
  let t24;
  if ($[27] !== t22 || $[28] !== t23) {
    t24 = <div className="m-0">{t22} like{t23}</div>;
    $[27] = t22;
    $[28] = t23;
    $[29] = t24;
  } else {
    t24 = $[29];
  }
  let t25;
  if ($[30] !== t18 || $[31] !== t24) {
    t25 = <div className="flex items-center gap-x-2 py-1 text-xs/3 font-light">{t18}{t19}{t24}</div>;
    $[30] = t18;
    $[31] = t24;
    $[32] = t25;
  } else {
    t25 = $[32];
  }
  let t26;
  if ($[33] !== t15 || $[34] !== t25 || $[35] !== t7) {
    t26 = <CardHeader><section>{t7}{t15}{t25}</section></CardHeader>;
    $[33] = t15;
    $[34] = t25;
    $[35] = t7;
    $[36] = t26;
  } else {
    t26 = $[36];
  }
  let t27;
  if ($[37] !== t2 || $[38] !== t26 || $[39] !== t6) {
    t27 = <NextLink hrefLang="en" href={t2} className="w-full truncate font-semibold">{t6}{t26}</NextLink>;
    $[37] = t2;
    $[38] = t26;
    $[39] = t6;
    $[40] = t27;
  } else {
    t27 = $[40];
  }
  let t28;
  if ($[41] !== d.user_display || $[42] !== d.user_id || $[43] !== showUser) {
    t28 = showUser && <section aria-label="Uploader Information"><Divider /><UserInfo userId={d.user_id as string} userDisplay={d?.user_display as Cruz.UserDisplay} /></section>;
    $[41] = d.user_display;
    $[42] = d.user_id;
    $[43] = showUser;
    $[44] = t28;
  } else {
    t28 = $[44];
  }
  let t29;
  if ($[45] !== t1 || $[46] !== t27 || $[47] !== t28) {
    t29 = <article aria-label={t1}>{t27}{t28}</article>;
    $[45] = t1;
    $[46] = t27;
    $[47] = t28;
    $[48] = t29;
  } else {
    t29 = $[48];
  }
  return t29;
};